// import external libraries
import { useTranslation } from 'react-i18next';

// import components
import { MultiSelect } from 'components/shared';

// import hooks
import { useBacklogFunctionOptions } from './BacklogFunctionFilter.hooks';

// import utils
import { costCentersOf, renderFilterTags } from '../../BacklogFilters.utils';

// import types
import type { FilterOption } from '../../../../Backlog.types';
import type { BacklogPlanUnitDrivenFilterProps } from '../BacklogEmployeeFilter/BacklogEmployeeFilter.types';

/**
 * The functions of the picked plan units, from the roster-functions call the plan unit preferences page
 * already uses — the same list a planner maintains there, so the two cannot disagree.
 *
 * Empty until a plan unit is picked, for the same reason the employee list is.
 */
const BacklogFunctionFilter = ({
  planUnits,
  startDate,
  endDate,
  selected,
  onChange
}: BacklogPlanUnitDrivenFilterProps) => {
  'use memo';

  const { t } = useTranslation('common', { keyPrefix: 'backlog' });
  const { t: tCommon } = useTranslation('common');
  const costCenters = costCentersOf(planUnits);

  const { data = [] } = useBacklogFunctionOptions(
    costCenters,
    startDate,
    endDate
  );

  const options: FilterOption[] = data.map(({ id, description }) => ({
    id: String(id),
    name: description
  }));

  return (
    <MultiSelect<FilterOption>
      label={t('filters.function')}
      options={options}
      selectedOptions={selected}
      onChange={onChange}
      optionLabelProp="name"
      // Emptied in one go rather than unticked value by value — see BacklogActivityFilter.
      disableClearable={false}
      disabled={!costCenters}
      renderTags={renderFilterTags(
        ({ name }) => name,
        tCommon('selected').toLowerCase()
      )}
    />
  );
};

export default BacklogFunctionFilter;
